import { isObject, isValidNumber } from "@pineapplelab/util";
import { FBase } from "../FBase";
import { PaymentMethodEnum } from "../../enums/paymentMethod.enum";
import { convertTimestampToDate } from "../../utils/utils";
import { Product } from "../product";

export class Order extends FBase {

	billingAddress: any = null; //TODO: Change type, TBD (might be moved to payment methods)
	products: Product[] = null;
	currency: string = null;
	userId: string = null;
	status: Order.PaymentStatus = null;
	totalAmount: number = null;
	paymentMethod: PaymentMethodEnum = null;

	__createdAtDate: Date = null;

	constructor(json?: { [key: string]: any }) {
		super();
		if (isObject(json)) {
			this.fromJson(json);
			this.setCreatedAtDate();
		}
	}

	setCreatedAtDate() {
		if (this.createdAt && isValidNumber(this.createdAt?.seconds)) {
			this.__createdAtDate = convertTimestampToDate(this.createdAt?.seconds);
		}
	}

}
export namespace Order {
	export const PATH = 'orders';

	export enum PaymentStatus {
		PENDING = 'PENDING',
		AUTHRECEIVED = 'AUTHRECEIVED',
		COMPLETE = 'COMPLETE',
		REVERSED = 'REVERSED',
		REFUND = 'REFUND',
		CANCELED = 'CANCELED',
	}
}
